import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const AvnuSwapLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo nostra__logo__avnuSwapLogo"
      version="1.1"
      id="Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 574 131"
      xmlSpace="preserve"
      height={14}
    >
      <path fill="#010E20" d="M134.46,7.45l60.19,113.61h14.93L269.77,7.45h-15.09l-52.4,98.84l-52.4-98.84H134.46z" />
      <path fill="#010E20" d="M398.49,7.45v93.65L305.85,7.45h-14.76v113.61h13.3V24.81l95.4,96.25h12.01V7.45H398.49z" />
      <path
        fill="#010E20"
        d="M553.33,7.45v59.24c0,27.92-16.71,45.12-46.24,45.12c-29.69,0-46.4-17.2-46.4-45.12V7.45h-13.63V67.5 c0,33.11,20.93,56.97,60.03,56.97s59.87-23.86,59.87-56.97V7.45H553.33z"
      />
      <path fill="#010E20" d="M140.39,120.69L80.18,7.45H65.24L5.03,120.69h15.09l52.42-98.52l52.42,98.52H140.39z" />
    </svg>
  );
};
export const AvnuSwapLogo = withLogo(AvnuSwapLogoComponent);
